<p-progressSpinner *ngIf="spinner" class="spinner_in_front"></p-progressSpinner>
<div class="ps-3 pe-3">
    <div class="row">
        <div class="col-8 col-sm-8 p-b-10-mbl">
            <label class="lbl_pos_field">{{'INGREDIENT_ITEM.NAME' | translate}}
                <i *ngIf="errorModel!=null && errorModel['Name']!=null"
                    class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
                    pTooltip="{{errorModel['Name']|translate}}" tooltipPosition="top"></i>
            </label>
            <input type="text" class="primary_input_field" [(ngModel)]="addIngredientItemModel.name">
        </div>
        <div class="col-4 col-sm-4 p-b-10-mbl">
                <label class="lbl_pos_field">{{'INGREDIENT_ITEM.UNIT' | translate}}
                    <i *ngIf="errorModel!=null && errorModel['UnitOfMeasurementId']!=null"
                        class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
                        pTooltip="{{errorModel['UnitOfMeasurementId']|translate}}" tooltipPosition="top"></i>
                </label>
                <p-dropdown class="pos_dropdown"  optionLabel="shortName"
                          optionValue="id" placeholder="{{'INGREDIENT_ITEM.SELECT_UNIT' | translate}}" [options]="UnitsOfMeasurments" [(ngModel)]="addIngredientItemModel.unitOfMeasurementId"></p-dropdown>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-2">
        <button *ngIf="!enableEdit" class="btn_login w-100" (click)="addIngredientItem(addIngredientItemModel)" >{{ 'SAVE' |
            translate}}</button>
        <button *ngIf="enableEdit" class="btn_login w-100" (click)="editIngredientItem(addIngredientItemModel)">{{ 'SAVE' |
            translate}}</button>
    </div>
</div>
<p-toast position="top-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>
